<div class="modal-header">
  <div class="modal-title">欢迎来到GreenPro</div>
</div>
<div>
  <div>
    欢迎来到菲尼克斯电气以 Proficloud
    数智化的工业平台底座，打造的面向企业的一站式低碳管理平台GreenPro。
  </div>
  <div>
    GreenPro致力于帮助用户算好每一吨碳，并且为用户的日常运营提供碳数据的实时监控，为节能降碳打下基础。
  </div>
</div>
<div class="modal-footer">
  <button nz-button nzType="primary" (click)="ok()">OK</button>
</div>
